import { useTranslation } from '@src/hooks/useTranslation'
import classNames from 'classnames'
import { type ReactNode } from 'react'
import styles from './UncoupledFooter.module.scss'

interface UncoupledFooterProps {
  hasBlackBackground?: boolean
}

export function UncoupledFooter(props: UncoupledFooterProps): ReactNode {
  const { hasBlackBackground } = props
  const translate = useTranslation()

  const privacyPolicyLink = '/other/legal/privacy'
  const cookiePolicyLink = '/other/legal/cookies'

  return (
    <footer
      className={classNames(styles.UncoupledFooter, {
        [styles.UncoupledFooter___hasBlackBackground]: hasBlackBackground,
      })}
    >
      <div className={styles.UncoupledFooter__layout}>
        <a className={styles.UncoupledFooter__link} href={privacyPolicyLink}>
          {translate('nav-privacy')}{' '}
        </a>
        <a className={styles.UncoupledFooter__link} href={cookiePolicyLink}>
          {translate('nav-cookies')}{' '}
        </a>
        <span className={styles.UncoupledFooter__logo}> NaturalCycles Nordic AB © </span>
      </div>
    </footer>
  )
}
